var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-layout content-container"},[_c('div',{staticClass:"main-container"},[_vm._t("main")],2),_c('div',{staticClass:"aside-container"},[_vm._t("aside")],2),_c('div',{staticClass:"extend-container"},[_vm._t("extend")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }